import { apiRequest } from "api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_ACTIVITY_LIST_BY_WORKFLOW_ID } from "./apiUrls";

const makeApiRequest = (req, options) => apiRequest(req, options); // 

export const getActivityListByWorkFlowID = createAsyncThunk(
  "activity-list/getActivityByWorkflowId",
  async (queryObj) => {
    const { workFlow_id, start, limit, sortBy, sortOrder } = queryObj;
    const req = GET_ACTIVITY_LIST_BY_WORKFLOW_ID(
      workFlow_id,
      start,
      limit,
      sortBy,
      sortOrder
    );
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await makeApiRequest(req, options,true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);
